module.exports = __webpack_public_path__ + "static/media/Nunito-Light.bf15505b.ttf";